import React from "react";
import { useTabContext } from "../context/context";
import { Controller, useFormContext } from "react-hook-form";

const AdvancedSearch = () => {
  const { filteredAdvSearch, setAdvServices, advServices, filteredShowAdvSearch } = useTabContext();
  const { control } = useFormContext();

  return (
    <div className="provider-section">
      <h3>Advanced Search</h3>
      {!filteredShowAdvSearch ? (
        <div className="my-4">
          <h4>You are not able to select any Advanced Search options as none of your services display these options in the search results</h4>
        </div>
      ) : (
        <div>
          <h4>Please select all that apply, these options will appear on the public search results page for site visitors to filter</h4>
          <div className="flex flex-wrap mt-2">
            {filteredAdvSearch.map((service, index) => {
              const taxonomyId = parseInt(service.taxonomy_id);
              return (
                <div key={index} className="mr-2 hover:cursor-pointer hover:bg-gray-100 p-1 rounded-md bg-gray-50 border-r border-b border-gray-200 mb-2">
                  <label htmlFor={`advSearch_${taxonomyId}`} className="ml-2 mb-0 hover:cursor-pointer">
                    <Controller
                      control={control}
                      name={`advanced_search.${taxonomyId}`}
                      defaultValue={advServices.includes(taxonomyId)}
                      render={({ field }) => (
                        <input
                          type="checkbox"
                          onChange={e => {
                            field.onChange(e);
                            if (e.target.checked) {
                              setAdvServices(prev => [...prev, taxonomyId]);
                            } else {
                              setAdvServices(prev => prev.filter(item => item !== taxonomyId));
                            }
                          }}
                          checked={field.value}
                          id={`advSearch_${taxonomyId}`}
                          className="ml-0 mr-2 hover:cursor-pointer"
                          {...field}
                        />
                      )}
                    />
                    {service.taxonomy_name}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdvancedSearch;
